import axiosInstance from "../interceptor/interceptor"; // Assuming axiosInstance is correctly configured
import dictionary from "../dictionary";

const { document } = dictionary;

const documentsServices = {
  getDocumentList: (paymentTypeId: any, loanTypeId?: any, isNewUniversity?: boolean) => {
    let url = `${document?.docList()}?payment_type_id=${paymentTypeId}&isNewUniversity=${isNewUniversity}`;
    if (loanTypeId) {
      url += `&loan_type_id=${loanTypeId}`;
    }
    return axiosInstance.get(url);
  },
  getDocumentFileList: (body: any) =>
    axiosInstance.post(document?.docFileList(), body),
  postDocumentUpload: (body: any) =>
    axiosInstance.post(document?.docUpload(), body),
  deleteDocumentFile: (body: any) =>
    axiosInstance.post(document?.docDelete(), body),
  getNewDocumentList: () => axiosInstance.get(document?.docNewList()),
  saveAllDocument: (body: any) =>
    axiosInstance.post(document?.saveAllDocument(), body),
  deleteAllDocument: (body: any) =>
    axiosInstance.post(document?.deleteAllDocument(), body),
  getAllDocumentFileList: (disbursementFormId: any) =>
    axiosInstance.get(
      `${document?.allDocFileList()}?disbursementFormId=${disbursementFormId}`
    ),
  submitAllDocument: (body: any) =>
    axiosInstance.post(document?.submitDocument(), body),
  reFetchDocument: (transactionId: any) =>
    axiosInstance.get(document?.reFetchDocument(transactionId)),
};

export default documentsServices;
